/**
 * Copyright 2024 Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { CurrentUserData } from "si-mfes-library/users/current-user-data.model";

// Interface for PendoData which includes current user and company data
export interface PendoData {
  currentUser: CurrentUserDataWithRoles;
  currentCompany: Company;
}

// Interface for CurrentUserDataWithRoles which extends CurrentUserData and includes roles
export interface CurrentUserDataWithRoles extends CurrentUserData {
  roles: Role[];
}

// Interface for Role which includes name
export interface Role {
  name: string;
}

// Interface for Company which includes id, name and services
export interface Company {
  id: string;
  name: string;
  services: CompanyService[];
}

// Interface for CompanyService which includes service
export interface CompanyService {
  service: Service;
}

// Interface for Service which includes serviceCode
export interface Service {
  serviceCode: ServiceCode;
}

// Enum for ServiceCode with all possible values
export enum ServiceCode {
  ALL = "ALL",
  API = "API",
  ARR = "ARR",
  CP = "CP",
  DDA = "DDA",
  DIA = "DIA",
  DPD = "DPD",
  DSP = "DSP",
  PDC = "PDC",
  PDE = "PDE",
  SA = "SA",
  SD = "SD",
  TOU = "TOU",
  TS = "TS",
  SHIR = "SHIR",
}
